export default function padNum(num, length = 1) {
	return num?.toString?.().padStart(length, 0);
}
